/* eslint-disable react-hooks/exhaustive-deps */
import React, {useEffect, useState} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import {useMutation, useQuery} from "@apollo/react-hooks";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import {Select} from "@material-ui/core";
import MenuItem from "@material-ui/core/MenuItem";
import Slider from "@material-ui/core/Slider";
import {CREATE_TASK, GET_TASK, UPDATE_TASK} from "../../database/queries/taskQueries";
import {notify} from "../../utils/notify";
import moment from "moment";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormHelperText from "@material-ui/core/FormHelperText";
import usePersistentStore from "../../persistentStore";
import {useHistory, useParams} from "react-router-dom";
import Button from "@material-ui/core/Button";
import {CREATE_WEB_HISTORY} from "../../database/queries/webHistoryQueries";

const useStyles = makeStyles(theme => ({
    root: {
        flexGrow: 1,
        '& p': {
            color: 'red',
        }
    },
    grow: {
        flexGrow: 1,
    },
    formControl: {
        'input': {
            '&::placeholder': {
                color: 'blue'
            }
        },
        '& .MuiFormLabel-root': {
            color: '#a0aec0'
        },
    },
    formControlError: {
        'input': {
            '&::placeholder': {
                color: 'red'
            }
        },
        '& .MuiFormLabel-root': {
            color: 'red'
        },
        '& .MuiInput-underline:before': {
            borderColor: 'red'
        },
    },
    gridContainer: {
        // overflow: 'auto',
        // overflowY: 'scroll',
        // padding: 10,
        // border: '1px solid #d3d4d5'
    },
    typeField: {
        paddingRight: 20
    },
    statusField: {
        paddingLeft: 10,
        paddingRight: 10
    },
    priorityField: {
        paddingLeft: 30,
        paddingRight: 30
    },
    leftField: {
        paddingRight: 10
    },
    middleField: {
        paddingLeft: 10,
        paddingRight: 10
    },
    rightField: {
        paddingLeft: 10,
    },
    hidden: {
        display: 'none',
    },
    noMargin: {
        marginBottom: 0,
        minHeight: 0
    },
    shrink: {
        transform: 'translate(0, 1.5px) scale(0.75)',
        transformOrigin: 'top left',
    }
}));

const marks = [
    {
        value: 1,
        label: 'Urgent',
    },
    {
        value: 2,
        label: '',
    },
    {
        value: 3,
        label: '',
    },
    {
        value: 4,
        label: '',
    },
    {
        value: 5,
        label: 'Low',
    },
];

const INITIAL_TASK = {
    taskId: null,
    parentType: '',
    parentId: null,
    shareCategoryType: '',
    shareCategoryId: null,
    taskName: '',
    taskDescription: '',
    taskType: '',
    taskStatus: 'not_started',
    taskPriority: 3,
    startAt: moment().format('YYYY-MM-DDTHH:mm'),
    dueAt: moment().format('YYYY-MM-DDTHH:mm'),
    completed: false,
    completedAt: moment('1970-01-01').format('YYYY-MM-DDTHH:mm'),
};

const PopupTaskEdit = props => {
    const classes = useStyles();
    const [globalPersistentState, globalPersistentActions] = usePersistentStore();
    const [task, setTask] = useState({
        ...INITIAL_TASK,
        parentType: props.parentEditType ? props.parentEditType : 'general',
        parentId: props.parentEditId ? props.parentEditId : 'general',
        shareCategoryType: props.shareCategoryType ? props.shareCategoryType : 'personal',
        shareCategoryId: props.shareCategoryId ? props.shareCategoryId : 'personal',
        taskName: globalPersistentState.popupQueryObj && globalPersistentState.popupQueryObj.selectionText ? globalPersistentState.popupQueryObj.selectionText : ''
    });
    const [errors, setErrors] = useState({});
    const history = useHistory();
    let {editId} = useParams();

    const {loading: getTaskLoading, error: getTaskError, data: getTaskData} = useQuery(GET_TASK, {
        skip: !editId || editId === 'new',
        variables: {taskId: editId},
    });

    const [updateTask, {error: updateTaskError}] = useMutation(UPDATE_TASK);
    const [createTask, {error: createTaskError}] = useMutation(CREATE_TASK);
    const [createWebHistory] = useMutation(CREATE_WEB_HISTORY);

    useEffect(() => {
        if (createTaskError) notify('createTaskError', 'error', createTaskError.message, null, null, globalPersistentState.popupQueryObj);
        if (getTaskError) notify('getTaskError', 'error', getTaskError.message, null, null, globalPersistentState.popupQueryObj);
        if (updateTaskError) notify('updateTaskError', 'error', updateTaskError.message, null, null, globalPersistentState.popupQueryObj);
    }, [createTaskError, getTaskError, updateTaskError]);

    useEffect(() => {
        if (getTaskData && getTaskData.task) {
            let fetchedTask = {
                taskId: getTaskData.task.taskId,
                parentType: getTaskData.task.parentType,
                parentId: getTaskData.task.parentId,
                shareCategoryType: getTaskData.task.shareCategoryType,
                shareCategoryId: getTaskData.task.shareCategoryId,
                taskName: getTaskData.task.taskName,
                taskDescription: getTaskData.task.taskDescription,
                taskType: getTaskData.task.taskType,
                taskStatus: getTaskData.task.taskStatus,
                taskPriority: getTaskData.task.taskPriority,
                startAt: moment(getTaskData.task.startAt).format('YYYY-MM-DDTHH:mm'),
                dueAt: moment(getTaskData.task.dueAt).format('YYYY-MM-DDTHH:mm'),
                completed: getTaskData.task.completed,
                completedAt: moment(getTaskData.task.completedAt).format('YYYY-MM-DDTHH:mm'),
            };

            setTask(fetchedTask);
            if (globalPersistentState.dirty) globalPersistentActions.setDirty(false);
        }
    }, [getTaskData]);

    useEffect(() => {
    }, [task]);

    useEffect(() => {
        if (globalPersistentState.dirty) globalPersistentActions.setDirty(false);
    }, []);

    // const contentCallback = useCallback(node => {
    //     if (node !== null && globalPersistentState.popupQueryObj && globalPersistentState.popupQueryObj.selectionUrl) {
    //         tellParentMessage({contentHeight: node.scrollHeight}, globalPersistentState.popupQueryObj)
    //     }
    // }, []);
    //
    // const onResize = (w, h) => {
    //     const fudge = 30;
    //     tellParentMessage({contentHeight: h + 30}, globalPersistentState.popupQueryObj)
    // };

    const handleChange = (e) => {
        if (e.target) {
            let value = e.target.value;
            if (e.target.name === 'completed') {
                value = !task.completed;
            }

            let updatedTask = {
                ...task,
                [e.target.name]: value
            };

            if (e.target.name === 'completed' && updatedTask.completed) {
                updatedTask.completedAt = moment().format('YYYY-MM-DDTHH:mm');
                updatedTask.taskStatus = 'completed';
            }

            setTask(updatedTask);
            if (!globalPersistentState.dirty) globalPersistentActions.setDirty(true);
        }
    };

    const handleSliderChange = (e, newValue) => {
        const updatedTask = {
            ...task,
            taskPriority: newValue
        };

        setTask(updatedTask);
        if (!globalPersistentState.dirty) globalPersistentActions.setDirty(true);
    };

    const validateForm = () => {
        setErrors({});
        let newError = {};
        if (!task.taskName || task.taskName.length < 3) newError.taskName = 'Task name must be at least 3 characters long';
        if (!task.parentType) newError.parent = 'Please select a Target Type';
        if (task.parentType && task.parentType !== 'general' && !task.parentId) newError.parent = 'Please choose a Target';
        if (!task.taskType) newError.taskType = 'Please select a Task Type';
        if (!task.taskStatus) newError.taskStatus = 'Please select a Task Status';
        if (!task.startAt) newError.startAt = 'Please enter a task start time';
        if (!task.dueAt) newError.dueAt = 'Please enter a task due time';
        if (moment(task.dueAt).diff(task.startAt) < 0) newError.dueAt = 'The task Due Time must be greater than its Start Time';
        if (task.completed && !task.completedAt) newError.completedAt = 'Please enter a task completed time';
        if (task.completed && moment(task.completedAt).diff(task.startAt) < 0) newError.completedAt = 'The task Completed Time must be greater than its Start Time';

        if (Object.keys(newError).length > 0) {
            setErrors(newError);
            return false;
        } else {
            return true;
        }
    };

    if (getTaskLoading) return <p>Loading ...</p>;

    return (
        <div>
            <form className={classes.root}>
                {task && (<>
                    <Grid container className={classes.gridContainer}>
                        <Grid item xs={6} className={classes.leftField}>
                            <FormControl
                                className={errors.taskName ? classes.formControlError : classes.formControl}
                                margin="dense"
                                size="small"
                                fullWidth
                            >
                                <TextField
                                    required
                                    id="taskName"
                                    name="taskName"
                                    label="Task name"
                                    fullWidth
                                    size="small"
                                    onChange={handleChange}
                                    value={task.taskName}
                                />
                                <FormHelperText>
                                    {errors.taskName}
                                </FormHelperText>
                            </FormControl>
                        </Grid>
                        <Grid item xs={6} className={classes.priorityField}>
                            <FormControl
                                className={classes.formControl}
                                margin="dense"
                                size="small"
                                fullWidth
                            >
                                <InputLabel id="label-task-priority" className={classes.shrink}>Task
                                    priority</InputLabel>
                                <Slider
                                    id="taskPriority"
                                    name="taskPriority"
                                    value={task.taskPriority}
                                    // labelid="label-task-priority"
                                    step={1}
                                    marks={marks}
                                    min={1}
                                    max={5}
                                    defaultValue={3}
                                    valueLabelDisplay="auto"
                                    helpertext="Task priority"
                                    onChange={handleSliderChange}
                                    // classes={{label: 'MuiInputLabel-shrink'}}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12}>
                            <FormControl
                                className={classes.formControl}
                                margin="dense"
                                size="small"
                                fullWidth
                            >
                                <TextField
                                    id="taskDescription"
                                    name="taskDescription"
                                    label="Task description"
                                    fullWidth
                                    size="small"
                                    multiline
                                    rowsMax="3"
                                    value={task.taskDescription}
                                    onChange={handleChange}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={4} className={classes.typeField}>
                            <FormControl
                                className={errors.taskType ? classes.formControlError : classes.formControl}
                                margin="dense"
                                size="small"
                                fullWidth
                                required
                            >
                                <InputLabel id="label-task-type">
                                    Task type
                                </InputLabel>
                                <Select
                                    required
                                    id="taskType"
                                    name="taskType"
                                    labelid="label-task-type"
                                    fullWidth
                                    size="small"
                                    value={task.taskType}
                                    onChange={handleChange}
                                >
                                    <MenuItem value="call" id="task-type-call">Call</MenuItem>
                                    <MenuItem value="email" id="task-type-email">Email</MenuItem>
                                    <MenuItem value="text" id="task-type-text">Text Message</MenuItem>
                                </Select>
                                <FormHelperText>
                                    {errors.taskType}
                                </FormHelperText>
                            </FormControl>
                        </Grid>
                        <Grid item xs={4} className={classes.statusField}>
                            <FormControl
                                className={errors.taskStatus ? classes.formControlError : classes.formControl}
                                margin="dense"
                                size="small"
                                fullWidth
                                required
                            >
                                <InputLabel id="label-task-status">Task status</InputLabel>
                                <Select
                                    required
                                    id="taskStatus"
                                    name="taskStatus"
                                    labelid="label-task-status"
                                    fullWidth
                                    size="small"
                                    value={task.taskStatus}
                                    onChange={handleChange}
                                >
                                    <MenuItem value="not_started" id="task-status-not-started">Not Started</MenuItem>
                                    <MenuItem value="in_progress" id="task-status-in-progress">In Progress</MenuItem>
                                    <MenuItem value="on_hold" id="task-status-on-hold">On Hold</MenuItem>
                                    <MenuItem value="completed" id="task-status-completed">Completed</MenuItem>
                                    <MenuItem value="cancelled" id="task-status-cancelled">Cancelled</MenuItem>
                                </Select>
                                <FormHelperText>
                                    {errors.taskStatus}
                                </FormHelperText>
                            </FormControl>
                        </Grid>
                        <Grid item xs={4} className={classes.rightField}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        id="completed"
                                        name="completed"
                                        checked={task.completed}
                                        onChange={handleChange}
                                        value={task.completed}
                                    />
                                }
                                label="Completed"
                            />
                        </Grid>
                        <Grid item xs={6} className={classes.leftField}>
                            <FormControl
                                className={errors.startAt ? classes.formControlError : classes.formControl}
                                margin="dense"
                                size="small"
                                fullWidth
                            >
                                <TextField
                                    id="startAt"
                                    name="startAt"
                                    type="datetime-local"
                                    helpertext="Start time"
                                    onChange={handleChange}
                                    value={task.startAt}
                                    required
                                    label="Start Time"
                                    fullWidth
                                    size="small"
                                />
                                <FormHelperText>
                                    {errors.startAt}
                                </FormHelperText>
                            </FormControl>
                        </Grid>
                        <Grid item xs={6} className={classes.rightField}>
                            <FormControl
                                className={errors.dueAt ? classes.formControlError : classes.formControl}
                                margin="dense"
                                size="small"
                                fullWidth
                            >
                                <TextField
                                    id="dueAt"
                                    name="dueAt"
                                    type="datetime-local"
                                    helpertext="Due time"
                                    onChange={handleChange}
                                    value={task.dueAt}
                                    required
                                    label="Due Time"
                                    fullWidth
                                    size="small"
                                />
                                <FormHelperText>
                                    {errors.dueAt}
                                </FormHelperText>
                            </FormControl>
                        </Grid>
                        <Grid item xs={6} className={classes.leftField}>
                            {task.completed && (<FormControl
                                className={errors.completedAt ? classes.formControlError : classes.formControl}
                                margin="dense"
                                size="small"
                                fullWidth
                            >
                                <TextField
                                    id="completedAt"
                                    name="completedAt"
                                    type="datetime-local"
                                    helpertext="Completed time"
                                    onChange={handleChange}
                                    className={task.taskStatus === 'completed' ? '' : 'hidden'}
                                    value={task.completedAt}
                                />
                                <FormHelperText>
                                    {errors.completedAt}
                                </FormHelperText>
                            </FormControl>)}
                        </Grid>
                    </Grid>
                    <Grid container className={classes.gridContainer}>
                        <Grid item xs={6} className={classes.leftField}>
                            <Button
                                id={"btn-cancel"}
                                fullWidth={true}
                                variant="contained"
                                onClick={() => {
                                    console.log('## SVR popupTaskEdit ## changing history', '/popup/' + props.parentEditType + '/' + props.parentEditId + '/tasks/' + props.shareCategoryType + '/' + props.shareCategoryId);
                                    history.push('/popup/' + props.parentEditType + '/' + props.parentEditId + '/tasks/' + props.shareCategoryType + '/' + props.shareCategoryId);
                                    props.parentRefresh();
                                }}
                                color="secondary"
                            >
                                Cancel
                            </Button>
                        </Grid>
                        <Grid item xs={6} className={classes.rightField}>
                            <Button
                                id={"btn-save"}
                                fullWidth={true}
                                variant="contained"
                                color="primary"
                                disabled={!globalPersistentState.dirty}
                                onClick={() => {
                                    if (validateForm()) {
                                        if (task.taskId && task.taskId !== 'new') {
                                            updateTask({
                                                variables: {
                                                    changedTask: {
                                                        taskId: task.taskId,
                                                        parentType: task.parentType,
                                                        parentId: task.parentId,
                                                        shareCategoryType: task.shareCategoryType,
                                                        shareCategoryId: task.shareCategoryId,
                                                        taskName: task.taskName,
                                                        taskDescription: task.taskDescription,
                                                        taskType: task.taskType,
                                                        taskStatus: task.taskStatus,
                                                        taskPriority: task.taskPriority,
                                                        startAt: moment(task.startAt).format(),
                                                        dueAt: moment(task.dueAt).format(),
                                                        completed: task.completed,
                                                        completedAt: moment(task.completedAt).format()
                                                    }
                                                }
                                            }).then(async (updateResult) => {
                                                if (globalPersistentState.popupQueryObj && globalPersistentState.popupQueryObj.selectionUrl) {
                                                    await createWebHistory({
                                                        variables: {
                                                            newWebHistory: {
                                                                parentType: 'task',
                                                                parentId: task.taskId,
                                                                url: globalPersistentState.popupQueryObj.selectionUrl
                                                            }
                                                        }
                                                    })
                                                }
                                                notify('updateTask', 'info', 'Task updated', null, null, globalPersistentState.popupQueryObj);
                                                globalPersistentActions.clearPopupQueryObjSelectionText();
                                                if (globalPersistentState.dirty) globalPersistentActions.setDirty(false);
                                                console.log('## SVR popupTaskEdit ## changing history', '/popup/' + props.parentEditType + '/' + props.parentEditId + '/tasks/' + props.shareCategoryType + '/' + props.shareCategoryId);
                                                history.push('/popup/' + props.parentEditType + '/' + props.parentEditId + '/tasks/' + props.shareCategoryType + '/' + props.shareCategoryId);
                                                props.parentRefresh();
                                            }).catch(e => {
                                                notify('updateTask', 'error', 'Problem creating task', null, null, globalPersistentState.popupQueryObj);
                                            })
                                        } else {
                                            createTask({
                                                variables: {
                                                    newTask: {
                                                        parentType: task.parentType,
                                                        parentId: task.parentId,
                                                        shareCategoryType: task.shareCategoryType,
                                                        shareCategoryId: task.shareCategoryId,
                                                        taskName: task.taskName,
                                                        taskDescription: task.taskDescription,
                                                        taskType: task.taskType,
                                                        taskStatus: task.taskStatus,
                                                        taskPriority: task.taskPriority,
                                                        startAt: moment(task.startAt).format(),
                                                        dueAt: moment(task.dueAt).format(),
                                                        completed: task.completed,
                                                        completedAt: moment(task.completedAt).format()
                                                    }
                                                }
                                            }).then(async (createResult) => {
                                                if (globalPersistentState.popupQueryObj && globalPersistentState.popupQueryObj.selectionUrl) {
                                                    await createWebHistory({
                                                        variables: {
                                                            newWebHistory: {
                                                                parentType: 'task',
                                                                parentId: createResult.data.createTask.id,
                                                                url: globalPersistentState.popupQueryObj.selectionUrl
                                                            }
                                                        }
                                                    })
                                                }
                                                notify('createTask', 'info', 'Task created', null, null, globalPersistentState.popupQueryObj);
                                                globalPersistentActions.clearPopupQueryObjSelectionText();
                                                if (globalPersistentState.dirty) globalPersistentActions.setDirty(false);
                                                console.log('## SVR popupTaskEdit ## changing history', '/popup/' + props.parentEditType + '/' + props.parentEditId + '/tasks/' + props.shareCategoryType + '/' + props.shareCategoryId);
                                                history.push('/popup/' + props.parentEditType + '/' + props.parentEditId + '/tasks/' + props.shareCategoryType + '/' + props.shareCategoryId);
                                                props.parentRefresh();
                                            }).catch(e => {
                                                notify('createTask', 'error', 'Problem creating task', null, null, globalPersistentState.popupQueryObj);
                                            })
                                        }
                                    }
                                }}
                            >
                                Save
                            </Button>
                        </Grid>
                    </Grid>
                </>)}
            </form>
        </div>
    )
};

export default PopupTaskEdit
